/**
 * PWA Service
 * 
 * Service worker registration and PWA utilities
 * 
 * @version 2.1.0
 */

/**
 * Register service worker
 */
export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      });
      
      console.log('SW registered:', registration.scope);
      
      // Handle updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New content available, notify user
            dispatchEvent(new CustomEvent('sw-update-available'));
          }
        });
      });
      
      return registration;
    } catch (error) {
      console.error('SW registration failed:', error);
    }
  }
};

/**
 * Setup install prompt for PWA
 */
let deferredPrompt = null;

export const setupInstallPrompt = () => {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    dispatchEvent(new CustomEvent('pwa-install-available'));
  });
};

/**
 * Trigger PWA install prompt
 */
export const promptInstall = async () => {
  if (!deferredPrompt) {
    console.log('Install prompt not available');
    return false;
  }
  
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  
  return outcome === 'accepted';
};

/**
 * Check if app is installed
 */
export const isInstalled = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
};

/**
 * Check online status
 */
export const isOnline = () => navigator.onLine;

/**
 * Subscribe to online/offline events
 */
export const subscribeToNetworkStatus = (callback) => {
  const handleOnline = () => callback(true);
  const handleOffline = () => callback(false);
  
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);
  
  return () => {
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
  };
};

export default {
  registerServiceWorker,
  setupInstallPrompt,
  promptInstall,
  isInstalled,
  isOnline,
  subscribeToNetworkStatus
};
